<div class="booble-backdrop">

    <div class=" xp-modal xp-modal-cadastro">
        <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
            <div class="modal-content">
                <div class="modal-header">

                    <div class="col-md-12">
                        <div class="header-title">Detalhe da ordem: Recebimento</div>
                        <p class="header-subtitle">Insira as informações abaixo para gerar invoice com a Xavi Pay.</p>
                    </div>
                    <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-dialog-scrollable-general">
                        <div class="form tpl-form-2 pt-0">

                            <form [formGroup]="orderForm">
    
                                <div class="form-row">
    
                                    <div class="col-md-12">
                                        <div class="form-subtitle">Dados do recebedor</div>
                                    </div>
    
                                    <div class="col-lg-5 col-md-6">
                                        <div class="line">
                                            <div class="label">Matriz/Filial<span class="text-danger"> *</span></div>
                                            <select formControlName="branch" placeholder="Selecione"
                                                class="js-control-branch custom-select">
                                                <option *ngFor="let branch of branchs" [ngValue]="branch">
                                                    {{branch}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-6">
                                        <div class="line">
                                            <div class="label">Valor<span class="text-danger"> *</span></div>
                                            <input formControlName="amount" currencyMask
                                                [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                                                (blur)="orderFormControl.amount.value < 0 ? orderFormControl.amount.setValue(0) : orderFormControl.amount.value; orderFormControl.amount.value >= 999999 ? orderFormControl.amount.setValue(999999) : orderFormControl.amount.value;"
                                                type="text" class="form-control" name="" required />
                                            <span class="text-danger"
                                                *ngIf="(orderFormControl.amount.touched) && orderFormControl.amount.errors?.required">
                                                Valor obrigatório
                                            </span>
                                        </div>
                                    </div>
    
                                    <div class="col-lg-2 col-md-6">
                                        <div class="line">
                                            <div class="label">Moeda<span class="text-danger"> *</span></div>
                                            <select placeholder="Selecione" formControlName="currency"
                                                class="custom-select js-control-currency" name="currency">
                                                <option *ngFor="let moeda of moedas" [value]="moeda">{{moeda}}</option>
                                            </select>
                                        </div>
                                    </div>
    
                                    <div class="col-lg-3 col-md-6">
                                        <div class="line">
                                            <div class="label">Conta de recebimento<span class="text-danger"> *</span></div>
                                            <select formControlName="account" placeholder="Selecione"
                                                class="js-control-account custom-select">
                                                <option *ngFor="let bank of bankAccounts" [ngValue]="bank.number">
                                                    {{'Bco ' + bank.name + ' | Ag. ' + bank.agency + ' | C. ' +
                                                    bank.number}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-6">
                                        <div class="line">
                                            <div class="label">Finalidade<span class="text-danger"> *</span></div>
                                            <select formControlName="finalityId" placeholder="Selecione"
                                                class="js-control-finality custom-select">
                                                <option *ngFor="let finality of finalities" [ngValue]="finality.id">
                                                    {{finality.description}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-7 col-md-6">
                                        <div class="line">
                                            <div class="label">Descrição<span class="text-danger"> *</span></div>
                                            <input formControlName="description" type="text" class="form-control" name=""
                                                required />
                                            <span class="text-danger"
                                                *ngIf="(orderFormControl.description.touched) && orderFormControl.description.errors?.required">
                                                Descrição obrigatória
                                            </span>
                                        </div>
                                    </div>
    
    
    
    
                                    <div class="col-md-12">
                                        <div class="mb-xl-0 mb-2">
                                            <div class="label">&nbsp;</div>
                                            <mat-slide-toggle formControlName="invoiceReceiverLogo"
                                                [checked]="orderFormControl.invoiceReceiverLogo.value">
                                                <label class="square mb-0">Adicionar logo do recebedor na
                                                    invoice
                                                </label>
                                            </mat-slide-toggle>
    
                                        </div>
    
                                    </div>
    
                                    <div class="col-md-12">
                                        <div class="mb-xl-0 mb-2">
                                            <div class="label">&nbsp;</div>
                                            <mat-slide-toggle formControlName="favorite"
                                                [checked]="orderFormControl.favorite.value">
                                                <label class="square mb-0">Adicionar pagador aos favoritos
                                                </label>
                                            </mat-slide-toggle>
    
                                        </div>
    
                                    </div>
    
    
                                    <div class="col-md-12">
                                        <div class="form-subtitle">Dados do pagador</div>
                                    </div>
    
                                    <div class="col-lg-5 col-md-6">
                                        <div class="line">
                                            <div class="label">Nome da empresa<span class="text-danger"> *</span></div>
                                            <input formControlName="companyName" type="text" class="form-control" name=""
                                                required />
                                            <span class="text-danger"
                                                *ngIf="(orderFormControl.companyName.touched) && orderFormControl.companyName.errors?.required">
                                                Nome da empresa obrigatório
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-6">
                                        <div class="line">
                                            <div class="label">País<span class="text-danger"> *</span></div>
                                            <select placeholder="Selecione" name=""
                                                [value]="orderForm.controls.country.value" formControlName="country"
                                                class="custom-select js-control-country">
                                                <option *ngFor="let country of countries" [ngValue]="country.nome">
                                                    {{country.nome}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-6">
                                        <div class="line">
                                            <div class="label">E-mail<span class="text-danger"> *</span></div>
                                            <input (keyup)="changeEmailForm()" formControlName="email" type="text" class="form-control" name=""
                                                required />
                                            <span class="text-danger"
                                                *ngIf="(orderFormControl.email.touched) && orderFormControl.email.errors?.required">
                                                E-mail obrigatório
                                            </span>
                                        </div>
                                    </div>
    
    
                                    <div class="col-md-12">
                                    </div>
                                </div>
    
                                <div class="dashboard-line-btn">
                                    <div class="form-row form-invoice">
                                        <div class="cols">
                                            <div class="form-group mb-0">
                                                <button (click)="openNewOrderModal()" type="button"
                                                    class="btn-xp-m2 btn-gray-new">
                                                    Voltar
                                                </button>
                                            </div>
                                        </div>
                                        <div class="cols col-md-6 col-lg-6 col-pc">
                                            <div class="mb-xl-0 mb-2">
    
                                                <label class="custom-checkbox-1 square">Enviar cópia do invoice para
                                                    pagador
                                                    <input type="checkbox"
                                                        [checked]="orderFormControl.copyinvoiceemail.value"
                                                        (change)="handleCopyinvoiceemail($event)">
                                                    <span id="checkmark-invoice" class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="cols">
                                            <div class="form-group mb-0">
                                                <button
                                                    [ngClass]="{'btn-gray-disabled': orderForm.invalid , 'btn-blue-30': !orderForm.invalid}"
                                                    [disabled]="orderForm.invalid || loading" (click)="sendInvoice()"
                                                    type="button" class="btn-xp-m2 btn-blue-30">
                                                    Gerar invoice
                                                    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>
